import { render, staticRenderFns } from "./bc-partner.vue?vue&type=template&id=5a2ab108&"
import script from "./bc-partner.vue?vue&type=script&lang=js&"
export * from "./bc-partner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports